//
// Module for the EmployerDirect User Accounts Index view
//
rs.module("system/configuration/employerdirectuseraccounts/index",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            var fundSelect = $.js(jsSelectors.filter).js(jsSelectors.fundSelect);
            var employerSelect = $.js(jsSelectors.filter).js(jsSelectors.employerSelect);

            // Register fund select change event
            fundSelect.change(function () {

                // populate employers on fund change
                selectHelper.getHelper(employerSelect).loadOptionsFrom(
                    backendUrls.getAvailableEmployers,
                    {
                        fundKey: $(this).val()
                    },
                    {
                        withBlank: true
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);